export const themes = {
  light: {
    bg: "#f6f5f1",
    bgCard: "#ffffff",
    bgElevated: "#ffffff",
    bgInput: "#f0efeb",
    bgOverlay: "rgba(0,0,0,0.42)",
    border: "#e2e0da",
    borderHover: "#cccac4",
    text: "#1a1a1f",
    textSecondary: "#52525b",
    textTertiary: "#71717a",
    textInverse: "#fff",
    accent: "#4f46e5",
    accentBg: "rgba(79,70,229,0.06)",
    accentBorder: "rgba(79,70,229,0.18)",
    success: "#059669",
    successBg: "rgba(5,150,105,0.06)",
    successBorder: "rgba(5,150,105,0.18)",
    error: "#dc2626",
    errorBg: "rgba(220,38,38,0.04)",
    errorBorder: "rgba(220,38,38,0.14)",
    warn: "#d97706",
    warnBg: "rgba(217,119,6,0.06)",
    progressTrack: "#e4e4e0",
    shadow: "0 8px 32px rgba(0,0,0,0.07)",
    shadowSm: "0 2px 8px rgba(0,0,0,0.04)",
    glow1: "rgba(79,70,229,0.03)",
    glow2: "rgba(5,150,105,0.02)",
    toastInfo: "#f0f4ff",
    toastInfoBorder: "#c7d2fe",
    toastSuccess: "#ecfdf5",
    toastSuccessBorder: "#a7f3d0",
    toastError: "#fef2f2",
    toastErrorBorder: "#fecaca",
    focusRing: "0 0 0 2px #fff, 0 0 0 4px #6366f1",
    subtleBg: "rgba(0,0,0,0.025)",
    checklistBg: "rgba(79,70,229,0.03)",
    checklistBorder: "rgba(79,70,229,0.1)",
  },
  dark: {
    bg: "#0c0c0f",
    bgCard: "#141418",
    bgElevated: "#18181e",
    bgInput: "#16161c",
    bgOverlay: "rgba(0,0,0,0.72)",
    border: "#26262e",
    borderHover: "#35353f",
    text: "#ededeb",
    textSecondary: "#a1a1aa",
    textTertiary: "#71717a",
    textInverse: "#0c0c0f",
    accent: "#818cf8",
    accentBg: "rgba(99,102,241,0.12)",
    accentBorder: "rgba(99,102,241,0.28)",
    success: "#34d399",
    successBg: "rgba(16,185,129,0.1)",
    successBorder: "rgba(16,185,129,0.25)",
    error: "#f87171",
    errorBg: "rgba(239,68,68,0.1)",
    errorBorder: "rgba(239,68,68,0.2)",
    warn: "#fbbf24",
    warnBg: "rgba(245,158,11,0.1)",
    progressTrack: "#26262e",
    shadow: "0 8px 32px rgba(0,0,0,0.45)",
    shadowSm: "0 2px 8px rgba(0,0,0,0.25)",
    glow1: "rgba(99,102,241,0.06)",
    glow2: "rgba(16,185,129,0.04)",
    toastInfo: "#1e293b",
    toastInfoBorder: "#334155",
    toastSuccess: "#064e3b",
    toastSuccessBorder: "#065f46",
    toastError: "#7f1d1d",
    toastErrorBorder: "#991b1b",
    focusRing: "0 0 0 2px #0c0c0f, 0 0 0 4px #818cf8",
    subtleBg: "rgba(255,255,255,0.04)",
    checklistBg: "rgba(99,102,241,0.06)",
    checklistBorder: "rgba(99,102,241,0.15)",
  },
};
